import { useEffect } from "react";
import { toast } from "sonner";

type AdminToastState = Readonly<{
  error?: string;
  success?: string;
  warning?: string;
}>;

export function useAdminToasts(
  { error, success, warning }: AdminToastState,
  scope: string,
) {
  useEffect(() => {
    if (error) toast.error(error, { id: `${scope}-error` });
  }, [error, scope]);

  useEffect(() => {
    if (success) toast.success(success, { id: `${scope}-success` });
  }, [scope, success]);

  useEffect(() => {
    if (warning) toast.warning(warning, { id: `${scope}-warning` });
  }, [scope, warning]);
}
